export default __webpack_public_path__ + "static/10_34-b4432f0fa0d398820f0c1a10b6702f6d.png";